import { h, Component } from "preact";
import Image from "../components/Image";
import { css } from "emotion";

import config from "../config";

const ic_plane = require("../assets/pages/notPublished/ic_airplane.svg");
const ic_binoculars = require("../assets/pages/notFound/ic_binoculars.svg");

const notPublishedClouds = "notPublished/ic_clouds.svg";
const notFoundClouds = "notFound/ic_clouds.svg";

const styleImage = css({
  width: "137px",
  height: "165px",
  marginBottom: "8px"
});

const EventError = ({ type = "notFound" }) => {
  const websiteURL = config("WEBSITE_URL");

  let clouds = null;
  let icon = null;
  let heading = null;
  let message = null;
  if (type === "notFound") {
    clouds = notFoundClouds;
    icon = ic_binoculars;
    heading = "Event not Found";
    message =
      "Check if your events URL is correct or continue exploring events";
  } else if (type === "noEvents") {
    clouds = notFoundClouds;
    icon = ic_binoculars;
    heading = "No Events Found";
    message = "";
  } else {
    clouds = notPublishedClouds;
    icon = ic_plane;
    heading = "This event is yet to launch";
    message = "Publish your event or contact your event organiser";
  }

  const styleDiv = {
    maxWidth: "800px",
    height: "454px",
    background: `url('../assets/pages/${clouds}') no-repeat`,
    backgroundSize: "contain",
    backgroundPosition: "center 9%",
    textAlign: "center",
    backgroundColor: "#F7FAFF",
    paddingTop: "80px",
    margin: "0 auto"
  };

  if (type === "notFound") {
    styleDiv.maxWidth = "487px";
    styleDiv.padding = "80px 14px";
  }

  const styleHeading = {
    fontWeight: "700",
    marginBottom: "6px"
  };

  const styleMessage = {
    color: "#6F7782",
    fontWeight: "700",
    marginBottom: "20px"
  };

  return (
    <div style={{ backgroundColor: "#F7FAFF" }}>
      <div style={styleDiv}>
        <Image src={icon} className={styleImage} alt="Error Image" />
        <h2 style={styleHeading}>{heading}</h2>
        <h3 style={styleMessage}>{message}</h3>
        {type !== "noEvents" ? (
          <a href={`${websiteURL}/search`}>
            <button
              class="btn btn-primary"
              aria-label="Search Events"
              aria-hidden={true}
            >
              Search Events
            </button>
          </a>
        ) : null}
      </div>
    </div>
  );
};
export default EventError;



// WEBPACK FOOTER //
// ./components/EventError.js